import api from '@/core/config/axios'

/**
 * Obtiene la cookie XSRF de Sanctum en el dominio de la API (requiere `withCredentials`).
 * Debe llamarse antes del POST a login u otras rutas API con CSRF en modo SPA.
 */
export const ensureSanctumCsrfCookie = () =>
  api.get('/sanctum/csrf-cookie', { withCredentials: true })
